// extracted by mini-css-extract-plugin
module.exports = {"navArrow":"ph","navArrowSvg":"pi","wrapper":"pj","reverse":"pk"};